import { Injectable } from "@angular/core";
import {
  Router,
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";

import { DataService } from "../../_service/data.service";

@Injectable({ providedIn: "root" })
export class DIGMGaurd implements CanActivate {
  constructor(private router: Router, private dataService: DataService) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let loginData = this.dataService.getCookies("loginData")
      ? JSON.parse(this.dataService.getCookies("loginData"))
      : JSON.parse(localStorage.getItem("loginData"));

    if (loginData && ["2", "3"].includes(loginData["user_role"])) {
      // is PAN India user & is logged in
      return true;
    }

    // not a DIGM user or not logged in return to home page
    this.dataService.showError("Access to this module is restricted");
    return false;
  }
}
